namespace GeniuzPOS.ReportMasterData {
    export interface Report_1602Form {
    }

    export class Report_1602Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1602';
    }
}
